module.exports = __webpack_public_path__ + "static/media/MudeSeuCorpo.c9a13df7.jpg";